module.exports = __webpack_public_path__ + "static/assets/bb9af7a1031a0b7abf9b991d67050cec.svg";